import {createContext} from '@chakra-ui/react-context';
import type {SystemStyleObject, ThemingProps} from '@chakra-ui/system';
import {createStylesContext} from '@chakra-ui/system';

import type {Part} from './theme/anatomy';

export type ButtonGroupContext = {
  /**
   * @default false
   */
  isDisabled?: boolean;
} & ThemingProps<'Button'>;

export const [ButtonGroupProvider, useButtonGroup] = createContext<ButtonGroupContext>({
  strict: false,
  name: `ButtonGroupContext`,
});

const ComponentName = `ButtonGroup` as const;

export const [StylesProvider, _useStyles] = createStylesContext(ComponentName);

export const useStyles = _useStyles as () => Record<Part, SystemStyleObject>;
